import { useQuery } from '@tanstack/react-query';
import { fetchPolicyRuleRawResult } from './helpers';

export const getQueryKey = (policyId: string, decisionId: number) => {
  return ['raw-trace-map', policyId, decisionId];
};

const useRawTraceMap = (
  policyId: string,
  decisionId: number,
  enabled = true,
) => {
  const { isLoading, data } = useQuery({
    queryKey: getQueryKey(policyId, decisionId),
    queryFn: () => fetchPolicyRuleRawResult(policyId, decisionId),
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    traceMap: data ?? null,
    isLoading: enabled ? isLoading : false,
  };
};

export default useRawTraceMap;
